import {
  apiConstants, getGeneric, postGeneric, putGeneric, deleteGeneric, postMultipart, getDownload,
} from '../../common/constants'

// Merchant serviceType config CRUD + CSV — calls the proship Java API
// (/api/allocation/config/service-type**), which reads/writes proship_pcis_prod. proship resolves
// a shipment's allocationServiceType from these rows at shipment creation; PACE stable-sorts by it.
const BASE = 'allocation/config/service-type'

// allocationServiceType vocabulary — exactly PACE's SLA-tier ladder tokens (case-exact).
export const SERVICE_TYPES = ['S2H', '24H', 'S4H', 'SDD', 'NDD', 'Surface', 'Air']
// Common serviceability zones (locality key). Blank = wildcard. CSV upload accepts any valid
// ServicabilityZone name; this list just covers the everyday ones for the on-screen dropdown.
export const ZONES = ['LOCAL', 'REGIONAL', 'METROS', 'ROI', 'SPECIAL', 'NORTH_EAST', 'WITHIN_ZONE']

// ── CRUD ─────────────────────────────────────────────────────────────────────
export const listServiceTypes = (merchantId) =>
  getGeneric(BASE, merchantId ? { merchantId } : {})
export const createServiceType = (body) => postGeneric(BASE, body)
export const updateServiceType = (id, body) => putGeneric(`${BASE}/${id}`, body)
export const deleteServiceType = (id) => deleteGeneric(`${BASE}/${id}`)

// ── CSV ──────────────────────────────────────────────────────────────────────
// Upload returns {status:'ok'} or {status:'rejected', errors:[...]} (nothing written on reject).
export const uploadServiceTypeCsv = (file) => {
  const fd = new FormData()
  fd.append('file', file)
  return postMultipart(`${BASE}/upload`, fd)
}
// Blob downloads — getDownload wants a FULL url (responseType:'blob' preserved for binary).
export const downloadServiceTypeCsv = (merchantId) =>
  getDownload(`${apiConstants.BASE_LOCAL}${BASE}/download${merchantId ? `?merchantId=${merchantId}` : ''}`)
export const downloadServiceTypeTemplate = () =>
  getDownload(`${apiConstants.BASE_LOCAL}${BASE}/template`)

// Save a blob response to a file (repo convention — no file-saver dep).
export const saveCsvBlob = (res, filename) => {
  const blob = new Blob([res.data], { type: 'text/csv;charset=utf-8' })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  link.click()
  URL.revokeObjectURL(url)
}
